import { useState } from "react";
import clsx from "clsx";
import type { CaseView } from "./caseView";
import styles from "./SlideMount.module.scss";

/* UI-DESIGN: LB-13 a case is a 35mm colour slide in a cream mount, lying
   on the lightbox so the light comes through it: a rounded window with the
   case art and a small printed label. Warm transparencies replace the B&W
   negatives, which read creepier than a dinner party should. This is the
   CSS version, used by the static stack (reduced motion, no WebGL); the
   three.js scene draws the same mount (slideArt.ts). Decorative: the case
   name and facts are in the chapter's heading and card. */
type SlideMountProps = {
  view: CaseView;
  className?: string;
};

const SlideMount = ({ view, className }: SlideMountProps) => {
  const [imageFailed, setImageFailed] = useState(false);
  const showArt = Boolean(view.imageUrl) && !imageFailed;
  return (
    <div className={clsx(styles.mount, className)} aria-hidden>
      <span className={styles.label}>Case {view.number}</span>
      <span className={styles.window}>
        {showArt ? (
          <img
            className={styles.art}
            src={view.imageUrl ?? undefined}
            alt=""
            loading="lazy"
            decoding="async"
            onError={() => setImageFailed(true)}
          />
        ) : (
          /* UI-DESIGN: no cover yet: a blank warm transparency with the
             case name, so the slot still reads as a slide */
          <span className={styles.blank}>{view.name}</span>
        )}
      </span>
      {/* UI-DESIGN: 2026-10-03 no printed name under the window: the card
          beside the slide is the title, and the caption said it twice */}
    </div>
  );
};

export default SlideMount;
